import { render, staticRenderFns } from "./TrademarkBulletinCheckForm.vue?vue&type=template&id=88e558bc&"
import script from "./TrademarkBulletinCheckForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkBulletinCheckForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkBulletinCheckForm.vue?vue&type=style&index=0&id=88e558bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports